export type Currency = {
  code: string;
  name: string;
  symbol: string;
  preferred: boolean;
};
